import React from 'react';
import PropTypes from 'prop-types';
import {
  CarouselProvider, Slider, Slide, ButtonBack, ButtonNext,
} from 'pure-react-carousel';
import { Icon } from '@resy/ui-kitchen';
import orderBy from 'lodash/orderBy';
import AmexGDAEditorialCard from './AmexGDAEditorialCard';
import Chevron from '../../../../images/icons/chevron-left.svg';
import Logger from '../../../../../../ui-kitchen/src/utils/logger';
import 'pure-react-carousel/dist/react-carousel.es.css';
import './AmexGDAEditorial.scss';

class AmexGDAEditorial extends React.Component {
  state = {
    blogDataResponseList: [],
  }

  async componentDidMount() {
    const { blogDataArray } = this.props;
    this.getEditorialData(blogDataArray);
  }

  getEditorialData = (blogDataArray) => {
    const blogDataResponseList = [];

    for (let index = 0; index < blogDataArray.length; index += 1) {
      const {
        _links, link, title, id, position,
      } = blogDataArray[index];
      const imageDownloadUrl = _links['wp:featuredmedia'][0].href;
      const cityCode = blogDataArray[index]['resy:market'].primary_market;
      let authorNames = '';
      try {
        let authArray = blogDataArray[index]['resy:authors'];
        authArray = authArray.map((item, count) => {
          authorNames = 'By ';
          if (count !== authArray.length - 1) {
            const autItem = `${item.name} \u00B7 `;
            return autItem;
          }
          return item.name;
        });
        for (let iCount = 0; iCount < authArray.length; iCount += 1) {
          authorNames = `${authorNames}${authArray[iCount]}`;
        }
      } catch (err) {
        Logger.error('author exception');
      }

      let imageLinkValue = '';
      let cityNameValue = '';
      let cityName;

      const imageLink = this.fetchImage(imageDownloadUrl);

      if (cityCode || cityCode !== '') {
        cityName = this.fetchCity(cityCode);
      }

      let obj = {
        link,
        title: title.rendered,
        id,
        position,
        author: authorNames,
      };

      imageLink.then((b) => {
        imageLinkValue = b;
        obj = {
          ...obj,
          imageLink: imageLinkValue,
        };
        if (cityName) {
          cityName.then((c) => {
            cityNameValue = c || '';
            obj = {
              ...obj,
              cityName: cityNameValue,
            };
            this.updateStateArray(blogDataResponseList, obj, blogDataArray);
            return null;
          });
        } else {
          this.updateStateArray(blogDataResponseList, obj, blogDataArray);
        }
      });
    }
  }

  updateStateArray = (blogDataResponseList, obj, blogDataArray) => {
    blogDataResponseList.push(obj);
    if (blogDataResponseList.length === blogDataArray.length) {
      const blogDataArrayReOrdered = orderBy(blogDataResponseList, ['position'], ['asc']);
      this.setState({ blogDataResponseList: blogDataArrayReOrdered });
    }
  }

  fetchImage = async (imageDownloadUrl) => {
    let blogResponseImage = '';

    try {
      const blogImageData = await fetch(imageDownloadUrl, {
        method: 'GET',
      });
      const blogResponseImageData = await blogImageData.json();
      blogResponseImage = blogResponseImageData.media_details.sizes.medium.source_url;
    } catch {
      return blogResponseImage;
    }

    return blogResponseImage;
  }

  fetchCity = async (cityCode) => {
    const { gdaEditorialApi } = this.props;
    const cityNameUrl = `${gdaEditorialApi}city_landing/?filter[meta_key]=code&filter[meta_value]=${cityCode}`;
    let cityName = '';

    try {
      const responseCityData = await fetch(cityNameUrl, {
        method: 'GET',
      });
      const blogResponseCityData = await responseCityData.json();
      cityName = blogResponseCityData[0].title.rendered;
    } catch {
      return cityName;
    }

    return cityName;
  }

  renderBackButton = () => (
    <ButtonBack aria-controls="editorialCarouser">
      <span className="Editorial__carousel-button-container" aria-hidden="true">
        <Icon
          name="Chevron"
          component={Chevron}
        />
      </span>
    </ButtonBack>
  );

  renderNextButton = () => (
    <ButtonNext aria-controls="editorialCarouser">
      <span className="Editorial__carousel-button-container" aria-hidden="true">
        <Icon
          name="Chevron"
          component={Chevron}
        />
      </span>
    </ButtonNext>
  );

  renderMobileCards = (blogDataResponseList) => {
    const {
      Analytics,
    } = this.props;
    const cards = [];
    const blogLength = blogDataResponseList.length;
    for (let i = 0; i < blogLength; i += 1) {
      cards.push((
        <AmexGDAEditorialCard
          key={blogDataResponseList[i].id}
          blogData={blogDataResponseList[i]}
          blogLen={blogLength}
          Analytics={Analytics}
        />
      ));
    }
    return cards;
  }

  render() {
    const { blogDataResponseList } = this.state;
    const {
      editorials, printContent, Analytics,
    } = this.props;

    const { heading } = editorials;
    if (blogDataResponseList.length === 0 || !blogDataResponseList) {
      return null;
    }

    const blogLen = blogDataResponseList.length;
    const visibleSlides = 4;
    return (
      <div className="GDA__Editorial">
        <div className="GDA__Editorial__header--content">
          <h2 id="editorialHeading" className="GDA__Editorial__header__title">
            {printContent(heading, 'heading')}
          </h2>
        </div>
        <div className="GDA__Editorial__mobile">
          <ul className="GDA__Editorial__mobile-grid">
            {blogDataResponseList && this.renderMobileCards(blogDataResponseList)}
          </ul>
        </div>
        <section
          className="GDA__Editorial__carousel"
          aria-labelledby="editorialHeading"
          aria-roledescription="carousel"
        >
          <CarouselProvider
            visibleSlides={visibleSlides}
            totalSlides={blogLen}
            step={4}
            dragEnabled={false}
            naturalSlideWidth={400}
            naturalSlideHeight={650}
            isIntrinsicHeight="true"
            id="editorialCarouser"
          >
            <div className="GDA__Editorial__carousel__container">
              {blogDataResponseList.length > 4 && this.renderBackButton()}
              <Slider tabIndex={-1}>
                {blogDataResponseList && blogDataResponseList.map((item, index) => (
                  <Slide
                    index={index}
                    key={item.id}
                    aria-label={`${index + 1} of ${blogDataResponseList.length}`}
                    aria-roledescription="slide"
                  >
                    <AmexGDAEditorialCard
                      key={item.id}
                      blogData={item}
                      isDesktop
                      Analytics={Analytics}
                    />
                  </Slide>
                ))}
              </Slider>
              {blogDataResponseList.length > 4 && this.renderNextButton()}
            </div>
          </CarouselProvider>
        </section>
      </div>
    );
  }
}

AmexGDAEditorial.defaultProps = {
  blogDataArray: [],
  editorials: { heading: '' },
};

AmexGDAEditorial.propTypes = {
  blogDataArray: PropTypes.arrayOf(PropTypes.shape({})),
  gdaEditorialApi: PropTypes.string.isRequired,
  editorials: PropTypes.shape({ heading: '' }),
  printContent: PropTypes.func.isRequired,
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
};

export default AmexGDAEditorial;
